import { z } from "zod";

/**
 * Crash and error reports from the Android app (P6-T16), sent to our own API
 * (`POST /api/client-errors`), no third-party service. They hold no personal
 * data: the error, where in the code, and which app build and update ran.
 */
export const clientErrorSchema = z.object({
	app: z.enum(["staff-android"]),
	appVersion: z.string().max(40),
	appBuild: z.number().int().nonnegative().nullable(),
	/** The over-the-air update that ran, null for the code built into the APK. */
	updateId: z.string().max(64).nullable(),
	runtimeVersion: z.string().max(128).nullable(),
	/** The app stopped (an uncaught error), or it went on (a screen's error, a rejected promise). */
	fatal: z.boolean(),
	/** `uncaught`, `render` (a screen failed to draw) or `promise`. */
	kind: z.enum(["uncaught", "render", "promise"]),
	name: z.string().max(200).nullable(),
	message: z.string().max(2000),
	stack: z.string().max(10_000).nullable(),
	/** The route the app showed, such as `/orders`. */
	route: z.string().max(200).nullable(),
	/** Android version and phone model, such as `Android 14 · Xiaomi 23053RN02I`. */
	device: z.string().max(200).nullable(),
	at: z.iso.datetime(),
});
export type ClientError = z.infer<typeof clientErrorSchema>;

/** One request carries the reports kept since the last one, at most 20. */
export const clientErrorBatchSchema = z.object({
	reports: z.array(clientErrorSchema).min(1).max(20),
});
export type ClientErrorBatch = z.infer<typeof clientErrorBatchSchema>;

export const CLIENT_ERRORS_PATH = "/api/client-errors";
